
export default function DownloadReportDirectiveController(
  reportsDataService,
) {
  const vm = this;

  vm.iconType = vm.iconType || 'download';
  vm.iconSizeClass = vm.iconSizeClass || 'md-36';
  vm.iconColorClass = vm.iconColorClass || 'fc-navanta-charcoal-75';
  vm.tooltip = 'Download Report';
  vm.handleClick = _handleClick;
  vm.createClass = _createClass;

  function _createClass() {
    return `${vm.iconSizeClass} ${vm.iconColorClass}`;
  }

  function _handleClick() {
    reportsDataService.downloadReport(vm.reportInstanceId).then((downloadReportResponse) => {
      reportsDataService.download(downloadReportResponse);
    });
  }
}

DownloadReportDirectiveController.$inject = [
  'reportsDataService',
];
